import { render } from "./TopPurchaser.vue?vue&type=template&id=32d4006a"
import script from "./TopPurchaser.vue?vue&type=script&lang=js"
export * from "./TopPurchaser.vue?vue&type=script&lang=js"

import "./TopPurchaser.vue?vue&type=style&index=0&id=32d4006a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__